'use client';

import { FeatherClock, FeatherSend } from '@subframe/core';

import type { JanelaAtendimentoBannerProps } from '@/shared/types/janelaAtendimentoTypes';
import { Button } from '@/shared/components/ui/common/Button';

const TEXTO_SEM_RESPOSTA = {
  titulo: 'Vamos tentar iniciar a conversa?',
  descricao:
    'Essa pessoa ainda não respondeu. Para iniciar o atendimento humano, clique em “Enviar mensagem de retomada”. O WhatsApp só permite que você escreva outras mensagens depois que ela responder.',
};

const TEXTO_JANELA_VENCIDA = {
  titulo: 'Vamos retomar o contato?',
  descricao:
    'Já passaram mais de 24 horas desde a última mensagem dessa pessoa, e o WhatsApp bloqueou o envio de mensagens livres. Para continuar o atendimento humano, clique em “Enviar mensagem de retomada”. Aguarde a resposta dela para voltar a escrever por aqui.',
};

export function JanelaAtendimentoBanner({
  nuncaRespondeu,
  onResume,
  isResending,
  resumeError,
}: JanelaAtendimentoBannerProps) {
  const texto = nuncaRespondeu ? TEXTO_SEM_RESPOSTA : TEXTO_JANELA_VENCIDA;

  return (
    <div
      role="status"
      className="border-warning-100 bg-warning-50 flex shrink-0 flex-col gap-3 border-t px-4 py-3"
    >
      <div className="flex items-start gap-2.5">
        <div className="flex min-w-0 flex-1 items-start gap-2.5">
          <FeatherClock className="text-warning-700 mt-px h-4 w-4 shrink-0" />
          <div className="min-w-0 flex-1">
            <p className="text-warning-800 text-sm font-medium">
              {isResending ? 'Enviando mensagem de retomada…' : texto.titulo}
            </p>
            <p className="text-warning-800 mt-1 text-xs">
              {isResending
                ? 'Aguarde a confirmação do envio. Você não precisa clicar novamente.'
                : texto.descricao}
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-2">
        <Button
          variant="brand-primary"
          size="small"
          loading={isResending}
          disabled={isResending}
          onClick={onResume}
          icon={<FeatherSend />}
          className="max-w-full shrink-0"
        >
          {isResending
            ? 'Enviando…'
            : resumeError
              ? 'Tentar enviar novamente'
              : 'Enviar mensagem de retomada'}
        </Button>
      </div>
      {resumeError ? (
        <p role="alert" className="text-error-700 text-xs">
          Não foi possível enviar a mensagem. {resumeError}
        </p>
      ) : null}
    </div>
  );
}
